<template>
	<div class="my-kefu">
		<!-- <p>客服电话 ：<a href="tel:4000567831">4000567831</a></p> -->
		<p>微信(电话) ：<a href="tel:13522884649">13522884649</a></p>
		<p>联系我时，请说是在“收到乐”平台看到的 谢谢!</p>
		<p><a href="https://beian.miit.gov.cn/">京ICP备2023015289号@copy right</a></p>
		<p>经营许可证编号 ：京B2-20223568</p>
	</div>
</template>

<script>
	export default {
	    name: "FooterKefu",
	    props:{
	        active:{
	            type: Number,
	            default: 1,
	        }
	    },
	
	    data(){
	        return{
	            tempActive:1,
	        }
	    },
	    mounted() {
	        // this.tempActive = this.active;
	    },
	}
</script>

<style>
	.my-kefu {
		margin-top: 10px;
		width: 100%;
		text-align: center;
		padding-bottom: 60rpx;
		font-size: 26rpx;
		color: #999999;
	}
	
	.my-kefu p {
		height: 24px;
		line-height: 24px;
	}
</style>